module.exports = __webpack_public_path__ + "static/media/minimap_sample1.5fb0ecdf.png";